/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const OrderAction = {
    WAIT_PAYMENT: 'WAIT_PAYMENT',
    CREATED: 'CREATED',
    PACKED: 'PACKED',
    DECORED: 'DECORED',
    TAKEN: 'TAKEN',
    SHIPPED: 'SHIPPED',
    RETURNED: 'RETURNED',
    RECEIVED: 'RECEIVED',
    REFUNDED: 'REFUNDED',
    CANCELLED: 'CANCELLED'
} as const;
export type OrderAction = typeof OrderAction[keyof typeof OrderAction];

